import React from 'react';
import * as actions from '../../../store/actions'
import {store} from '../../../store'
import {connect} from 'react-redux'

import FormFlowStep from "./FormFlowStep";


class FormFlow extends React.Component {

    // constructor(props) {
    //
    //     super(props)
    //     this.title = config.title || '';
    //     this.reduxPath = config.REDUX_PATH || '';
    //     this.steps = config.steps.map(d => new FormFlowStep({...d, REDUX_PATH: config.REDUX_PATH}));
    // }

    componentDidMount() {
        // this.props.setCurrStep(1);
        this.props.onStart && this.props.onStart();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currStep !== this.props.currStep) {
             if (this.props.currStep > this.props.steps.length) {
                  this.props.onComplete && this.props.onComplete();
             }
        }
    }

    render() {
        return (
            <div className={'ff-step-wrapper'}>
                {this.props.steps && !!this.props.steps.length &&
                    <FormFlowStep {...this.props.steps[this.props.currStep - 1]}/>
                }
            </div>
        )
    }

}



const mapStateToProps = state => ({
    currStep: state.formFlow.currStep,
    responses: state.formFlow.inputs,
    computed: state.formFlow.computed,

})

const mapDispatchToProps = dispatch => ({
    updateInputs: data => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateComputed: data => dispatch(actions.formFlow.updateFormFlowComputed(data)),
    setCurrStep: data => dispatch(actions.formFlow.setFormFlowCurrStep(data))
})


export default connect(mapStateToProps, mapDispatchToProps)(FormFlow)


/*
CONFIG FORMATS FOR PROPS DICTIONARY TO GET PASSED TO FORM FLOW

*FORM FLOW PROPERTIES*
title,
onStart () => {} get any data that you might need to run your form flow and do any other activities
onComplete () => {} whatever you want to do when we finish the form flow.


*FORM STEP PROPERTIES*
getComponent -- a valid component to be rendered inside the step,
populateWithData() -- how to populate the component with data from the redux store
handleInput() -- what to do when the user inputs data
areStepReqsMet -- (state) => {} a function that is passed the redux state along the specified path. If reqs are met, then we can move them along. ht

// ABOVE FOUR NOT REQUIRED IF WE USE INPUTS
inputs -- a valid json config for a series of inputs. (See the inputs react file). If this is used, you DO NOT need to pass component or populateWithData function
                -- this will default generate a FormFlowStepForm (see forms folder in theme section), and will populate the inputs using get(reduxState, [REDUX_PATH].inputs)



onNext() -- what to do when we go to the next step
onPrev() -- what to do when we go back a step

one more quick note: instead of component, you can can also pass key components, which is an array. This is an array of objects, where we look for two keys:

if you do this, then the first element in the array is displayed by default. The onNext isn't fired until all components have been displayed.
 {
    getComponent // the component
    shouldDisplay() // whether or not we should display,
    checkOnDataUpdate: // whether or not we should check display on every update, or just on the next button. defaults to false.

 }

 You can use this same format for the inpputs:

 inputs : [
    [
        inputs: [],
        shouldDisplay,
        checkOnDataUpdate
    ],
    [
        inputs: [],
        shouldDisplay,
        checkOnDataUpdate
    ],
 ]

shape of config:

    {
        ...formFlowProps,
        steps: [
            {..step1Props}, {...step2Props}
        ]
    }


 */
